var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"journal-map",style:(`height: ${_vm.height}px`),attrs:{"id":"journal-map"}},[(_vm.mapgl)?_c('r-map-tools',{attrs:{"tools":['baselayers', 'screenshot'],"baselayer-id":_vm.baselayerId,"map":_vm.mapgl},on:{"toggle-base-layer":_vm.toggleBaselayer}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }